var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"dark":"","padless":""}},[_c('v-card-text',{staticClass:"py-2 white--text text-center"},[_vm._v(" "+_vm._s(new Date().getFullYear())+" — "),_c('strong',[_vm._v("© Anson")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }